export default __webpack_public_path__ + "static/media/TappingImg.8619b7a7.jpg";